var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "rbvQuestionnaireQuestion", class: _vm.questionClasses },
    [
      _c(
        "label",
        {
          staticClass: "rbvQuestionnaireQuestionLabel",
          class: _vm.labelClasses,
          attrs: { for: _vm.updatedTemplate.id },
        },
        [
          _c(
            "span",
            {
              staticClass: "rbvQuestionnaireQuestionLabelOrd",
              class: _vm.classes,
            },
            [_vm._v(_vm._s(_vm.updatedTemplate.ord) + ".")]
          ),
          _c("span", [_vm._v(_vm._s(_vm.updatedTemplate.name))]),
        ]
      ),
      _vm.updatedTemplate.type === "DATE"
        ? _c("question-date", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: _vm.validations,
                expression: "validations",
              },
            ],
            staticClass: "rbvQuestionnaireQuestionInput",
            attrs: {
              id: _vm.updatedTemplate.id,
              name: _vm.updatedTemplate.id,
              placeholder: _vm.updatedTemplate.placeholder,
              value: _vm.vModel,
              readonly: !!_vm.updatedTemplate.readonly,
            },
            on: { blur: _vm.onChange },
          })
        : _vm.updatedTemplate.type === "LIST"
        ? _c("question-list", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: _vm.validations,
                expression: "validations",
              },
            ],
            attrs: {
              id: _vm.updatedTemplate.id,
              name: _vm.updatedTemplate.id,
              template: _vm.updatedTemplate,
              "is-user-defined": _vm.isUserDefined,
              value: _vm.vModel,
              readonly: !!_vm.updatedTemplate.readonly,
            },
            on: { input: _vm.onChange },
          })
        : _c("question-text", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: _vm.validations,
                expression: "validations",
              },
            ],
            staticClass: "rbvQuestionnaireQuestionInput",
            attrs: {
              id: _vm.updatedTemplate.id,
              name: _vm.updatedTemplate.id,
              placeholder: _vm.updatedTemplate.placeholder,
              value: _vm.vModel,
              readonly: !!_vm.updatedTemplate.readonly,
            },
            on: { input: _vm.onChange },
          }),
      _c("tooltip", {
        attrs: {
          ord: _vm.updatedTemplate.ord,
          title: _vm.updatedTemplate.name,
          description: _vm.updatedTemplate.description,
          required: !!_vm.isRequired,
          error: _vm.showErrors && _vm.errors.first(_vm.updatedTemplate.id),
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }